import React, { useEffect, useState } from 'react';
import styles from './notFound.module.css';  

const NotFound = () => {
  const [seconds, setSeconds] = useState(5); // Initialize countdown timer

  useEffect(() => {
    // Start countdown
    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1); // Decrement seconds
    }, 1000);

    // Redirect after 5 seconds
    const redirectTimer = setTimeout(() => {
      window.location.href = '/home'; // Redirect to home
    }, 5000);

    // Cleanup the timers on component unmount
    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, []);

  return (
    <div className={`${styles.notFoundcontainer}`}>
      <h1 className={`${styles.notFoundtitle}`}>404</h1>
      <p className={`${styles.notFoundMessage}`}>
        Oops! The page you are looking for does not exist.
      </p>
      <p className={styles.countdownMessage}>
        You will be redirected to the home page in {seconds} seconds.
      </p>      <a href="/home" className={`${styles.notFoundHomeButton}`}>
        Go to Home
      </a>
      {/* <img 
        src="https://example.com/your-image.png" 
        alt="Not Found Illustration" 
        className={`${styles.notFoundImage}`}
      /> */}
    </div>
  );
};

export default NotFound;
